import { EvIoTournamentTileLabel } from 'modules/tournaments/components/TournamentTile/EvIoTournamentTileLabel';
import { useTournamentPlatformType } from 'modules/tournaments/hooks';
import React, { FC, useMemo } from 'react';
import { TournamentEntity } from 'app/interfaces/entity';
import { PlatformType } from '@okletsplay/core';
import { useStyles } from './TournamentTileTypeLabel.styles';
import { Typography } from '@mui/material';
import { ChessMatchTypeFormat } from 'shared/components/Format/ChessMatchTypeFormat';

interface ComponentProps {
  tournament: TournamentEntity;
}

export const TournamentTileTypeLabel: FC<ComponentProps> = ({ tournament }) => {
  const { classes } = useStyles();
  const { checkIsKnockoutEnabled } = useTournamentPlatformType();

  const {
    teamsSettings: { teamSize },
    game: { platformType },
    matchSetupSettings: settings,
  } = tournament;

  const isKnockoutTournament = useMemo(
    () => checkIsKnockoutEnabled(tournament?.game?.platformType),
    [checkIsKnockoutEnabled, tournament?.game?.platformType]
  );

  const defaultLabel = useMemo(() => {
    if (isKnockoutTournament) {
      return `Standard | ${teamSize}V${teamSize}`;
    }

    return 'Standard';
  }, [isKnockoutTournament, teamSize]);

  const label = useMemo(() => {
    switch (platformType) {
      case PlatformType.Lichess:
        return (
          <Typography className={classes.root}>
            {`${defaultLabel} | `}
            <ChessMatchTypeFormat limit={settings.clockLimit} increment={settings.clockIncrement} />
          </Typography>
        );
      case PlatformType.EvIo:
        return (
          <Typography className={classes.root}>
            <EvIoTournamentTileLabel
              teamSize={teamSize}
              gameMode={settings.gameMode}
              gameDuration={settings.gameDuration}
            />
          </Typography>
        );
      default:
        return <Typography className={classes.root}>{defaultLabel}</Typography>;
    }
  }, [classes.root, defaultLabel, platformType, settings, teamSize]);

  return <>{label}</>;
};
